import ApiPlayground from "@components/api-playground";

export default function Page() {
  return <ApiPlayground/>;
}
